import React from 'react';

import './style.css';

/**
 * SeoBlock — ВИДИМЫЙ текстовый SEO-блок (h1 + описание) для низа страницы (над футером).
 *
 * Это НЕ скрытый текст и НЕ сквозной футер: блок монтируется индивидуально в каждую страницу,
 * текст уникален для страницы, поэтому поисковики воспринимают его как обычный контент.
 * Попадает в HTML пререндера для ботов (server/server/seo).
 *
 * props:
 *   title — текст h1 (заголовок страницы) — обязателен для страницы без своего h1
 *   intro — вводный абзац (необязательно)
 *   items — массив { label, text } → семантический список (необязательно)
 *   outro — завершающий абзац (необязательно)
 */
const SeoBlock = ({ title, intro, items, outro }) => (
    <div className='seo_block'>
        {title ? <h1 className='seo_block_title'>{title}</h1> : null}
        {intro ? <p className='seo_block_text'>{intro}</p> : null}
        {items && items.length ? (
            <ul className='seo_block_list'>
                {items.map((item, index) => (
                    <li key={`seo-block-item-${index}`}>
                        {item.label ? <b>{item.label}</b> : null}
                        {item.label ? ' — ' : null}
                        {item.text}
                    </li>
                ))}
            </ul>
        ) : null}
        {outro ? <p className='seo_block_text'>{outro}</p> : null}
    </div>
);

export default SeoBlock;
